/* unplugin-vue-components disabled */import { render } from "./NavigationBar.vue?vue&type=template&id=67b6f137"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=67b6f137&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__